import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async addComplaint({ dispatch, commit }, complaint) {
    try {
      const { data } = await request.post('complaints', complaint);
      if (data.error) {
        throw Error('Server-side validation failed');
      }
    } catch (err) {
      throw err;
    }
  },
};

export default actions;
